import {
  COLOR_TOKEN_COPY,
  type ColorToken,
} from "../../../../packages/shared/src/schedule-color.ts";

// The template color chip: a small hue square plus the token's NAME in text.
//
// Two rules from the 6B design doctrine live here. (1) The token drives a CLASS from the
// closed allowlist, never an inline style - an unvalidated server string can therefore
// never be interpolated into a color value. (2) The name always renders beside the square
// (WCAG 1.4.1): a supervisor with deuteranopia, or one reading a printed export, loses
// decoration and nothing else.

export function TemplateColorChip({ colorToken }: { colorToken: ColorToken }) {
  return (
    <span className={`tpl-color tpl-color--${colorToken}`}>
      <span className="tpl-color__dot" aria-hidden="true" />
      {COLOR_TOKEN_COPY[colorToken]}
    </span>
  );
}
